import { useEffect, useRef, useState } from 'react';
import jquery from 'jquery';
import 'summernote/dist/summernote-lite.min.js';
import 'summernote/dist/summernote-lite.min.css';
import 'summernote/dist/lang/summernote-ko-KR';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getMAGAE020, postMAGAE020, putMAGAE020 } from '../../../services/Api';
import SideMenu from '../../../shared/components/SideMenu';

import { MENU_MENUS, MESSAGE } from '../../../shared/constants/app';
import { handleFocus } from '../../../utils';
const MAGAE020 = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const editorRef = useRef(null);

    useEffect(() => {
        jquery(editorRef.current).summernote({
            height: 300,
            lang: 'ko-KR',
            placeholder: '내용을 입력하세요...',
            toolbar: [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'video']],
                ['view', ['codeview']],
            ],
        });
    }, []);

    const [data, setData] = useState({
        gubun: 'INTERVIEW',
        title: '',
        bizCompany: '',
        columnist: '',
        ftsContents: '',
        content: '',
        dspYN: 'N',
    });

    useEffect(() => {
        if (id) {
            getMAGAE020(id)
                .then(({ data }) => {
                    setData({
                        seq: id,
                        gubun: data.gubun,
                        title: data.title,
                        bizCompany: data.bizCompany,
                        columnist: data.columnist,
                        content: jquery(editorRef.current).summernote('code'),
                        ftsContents: jquery(editorRef.current)
                            .summernote('code')
                            .replace(/<\/p>/gi, '\n')
                            .replace(/<br\/?>/gi, '\n')
                            .replace(/<\/?[^>]+(>|$)/g, ''),
                        dspYN: data.dspYN,
                    });
                    if (editorRef.current) {
                        jquery(editorRef.current).summernote('code', data.content);
                    }
                })
                .catch((error) => console.log(error));
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    const handleSave = () => {
        if (!data?.title || data?.title === '') {
            window.alert('교육명을 입력해 주세요.');
            handleFocus('title');
            return;
        }
        if (!data?.bizCompany || data?.bizCompany === '') {
            window.alert('장소를 입력해 주세요.');
            handleFocus('bizCompany');
            return;
        }
        if (!data?.columnist || data?.columnist === '') {
            window.alert('연자를 입력해 주세요.');
            handleFocus('columnist');
            return;
        }

        const content = jquery(editorRef.current).summernote('code').trim();
        if (!content || content === '<p><br></p>') {
            window.alert('상세내용을 입력해 주세요.');
            handleFocus('editorMAGAE020');
            return;
        }

        const isConfirmed = window.confirm('등록/수정하시겠습니까?');
        const message = '등록/수정되었습니다.';
        if (isConfirmed) {
            if (id) {
                putMAGAE020({
                    seq: id,
                    gubun: data.gubun,
                    title: data.title,
                    bizCompany: data.bizCompany,
                    columnist: data.columnist,
                    content: jquery(editorRef.current).summernote('code'),
                    ftsContents: jquery(editorRef.current)
                        .summernote('code')
                        .replace(/<\/p>/gi, '\n')
                        .replace(/<br\/?>/gi, '\n')
                        .replace(/<\/?[^>]+(>|$)/g, ''),
                    dspYN: data.dspYN,
                })
                    .then(() => {
                        window.alert(message);
                        navigate('/magae010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.notify.updateError);
                    });
            } else {
                postMAGAE020({
                    gubun: data.gubun,
                    title: data.title,
                    bizCompany: data.bizCompany,
                    columnist: data.columnist,
                    content: jquery(editorRef.current).summernote('code'),
                    ftsContents: jquery(editorRef.current)
                        .summernote('code')
                        .replace(/<\/p>/gi, '\n')
                        .replace(/<br\/?>/gi, '\n')
                        .replace(/<\/?[^>]+(>|$)/g, ''),
                    dspYN: data.dspYN,
                })
                    .then(() => {
                        window.alert(message);
                        navigate('/magae010');
                    })
                    .catch((error) => {
                        console.log(error);
                        window.alert(MESSAGE.notify.createError);
                    });
            }
        }
    };
    return (
        <div className="container dental-magazine">
            <div className="wrap">
                <SideMenu menu={MENU_MENUS} />
                <div className="dental-magazine-content content-right">
                    <h1 className="title">덴탈매거진 등록</h1>
                    <div id="dental-magazine-content-list">
                        <table className="table-gray">
                            <tbody>
                                <tr>
                                    <th>
                                        <span>구분</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box">
                                            <select name="gubun" value={data?.gubun} onChange={handleChange}>
                                                <option value="INTERVIEW">탐방</option>
                                                <option value="COLUMN">덴탈칼럼</option>
                                                <option value="QNA">Q&A</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>교육명</span>
                                    </th>
                                    <td colSpan={3}>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="교육명 입력"
                                            value={data?.title}
                                            onChange={handleChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>장소</span>
                                    </th>
                                    <td>
                                        <input
                                            type="text"
                                            name="bizCompany"
                                            placeholder="장소 입력"
                                            value={data?.bizCompany}
                                            onChange={handleChange}
                                        />
                                    </td>
                                    <th className="border-l-ddd border-b-ddd">
                                        <span>연자</span>
                                    </th>
                                    <td>
                                        <input
                                            type="text"
                                            name="columnist"
                                            placeholder="연자 입력"
                                            value={data?.columnist}
                                            onChange={handleChange}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>상세내용</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div id="editorMAGAE020" style={{ height: '300px' }} ref={editorRef}></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>
                                        <span>공개여부</span>
                                    </th>
                                    <td colSpan={3}>
                                        <div className="select-box">
                                            <select name="dspYN" value={data?.dspYN} onChange={handleChange}>
                                                <option value="N">비공개</option>
                                                <option value="Y">공개</option>
                                            </select>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="bottom-content">
                        <Link to={'/magae010'} className="button-back-to-list">
                            목록
                        </Link>
                        <Link onClick={() => handleSave(id)} className="button-save">
                            등록/수정
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default MAGAE020;
